<script lang="ts" setup>
import type { PropType } from 'vue';

import type { BasePaginationProps } from '~/components/Base/BasePagination.vue';
import type { SaleListingItemEntity } from '~/types/sale.type';

// PROPS
const { sales, pagination, isLoading } = defineProps({
    sales: { type: Array as PropType<SaleListingItemEntity[]>, default: () => [] },
    isLoading: { type: Boolean, required: true },
    showTrustReportBanner: { type: Boolean, default: false },
    pagination: { type: Object as PropType<Omit<BasePaginationProps, 'disabled'>>, required: true },
});

// DATA
const showEmptyState = computed(() => !isLoading && pagination.total === 0);
</script>

<template>
    <slot v-if="showEmptyState" name="empty-state"> </slot>
    <div v-else class="mb-8 flex w-full flex-col gap-8 md:grid md:grid-cols-2 xl:grid-cols-3">
        <template v-if="isLoading">
            <template v-for="() in Array.from(Array(pagination.itemsPerPage).keys())">
                <slot name="skeleton" />
            </template>
        </template>
        <template v-else>
            <template v-for="(sale, i) in sales" :key="sale.id">
                <slot :sale="sale"></slot>

                <template v-if="showTrustReportBanner">
                    <!-- Mobile -->
                    <MktgTrustReport v-if="i == 2" class="md:hidden" />
                    <!-- Tablet -->
                    <MktgTrustReport v-if="i == 5" class="hidden md:col-span-2 md:flex xl:hidden" />
                    <!-- Desktop -->
                    <MktgTrustReport v-if="i == 8" class="hidden xl:col-span-3 xl:flex" />
                </template>
            </template>
        </template>
    </div>

    <BasePagination
        v-if="pagination.total > 0"
        v-bind="pagination"
        size="lg"
        class="w-full justify-center md:border-t md:border-neutral-300 md:pt-8"
        :disabled="isLoading"
    />
</template>
